/*
 * @Author: Long
 * @Date: 2021-05-05 17:49:04
 * @LastEditors: Long
 * @LastEditTime: 2022-03-21 15:32:55
 */
const service = require('@/assets/js/request')

class database {
  /**
   * 基因座
   */
  static getFiledList (target) {
    service.request({
      method: 'POST',
      url: 'getFiledList',
      params: {
        token: localStorage.getItem('token')
      }
    }).then(res => {
      if (res.code === '2001') {
        target.titlelist = res.data
      } else {
        target.$message({
          message: res.msg,
          type: 'warning'
        })
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
  /**
   * 基因对比
   */
  static getDataContrast (target) {
    service.request({
      method: 'POST',
      url: 'getDataContrast',
      params: {
        type: 1,
        user_id: target.userid,
        token: localStorage.getItem('token'),
        contrast_str: target.ruleForm
      }
    }).then(res => {
      if (res.code === '2001') {
        if (res.data.length > 0) {
          target.iscontrast = false
          for (let key in res.data[0]) {
            if (key !== 'id' && key !== 'probability' && key !== 'status' && key !== 'Name') {
              target.tablelist.push(key)
            }
          }
          target.num = res.data.length
          res.data.unshift(target.ruleForm)
        } else {
          target.iscontrast = true
        }
        target.tableData = res.data
      } else {
        target.$message({
          message: res.msg,
          type: 'warning'
        })
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
}

export default database



// WEBPACK FOOTER //
// ./src/views/database/database.js